/* tslint:disable */

declare var Object: any;
export interface TsaimembersettingInterface {
  "userId": number;
  "empId": string;
  "companyId": number;
  "aiCode": number;
  "showAi"?: number;
  "showType"?: number;
  "freqValue"?: string;
  "additionalFilter"?: string;
  "createdDate"?: Date;
  "createdBy"?: string;
  "modifiedDate"?: Date;
  "modifiedBy"?: string;
}

export class Tsaimembersetting implements TsaimembersettingInterface {
  "userId": number;
  "empId": string;
  "companyId": number;
  "aiCode": number;
  "showAi": number;
  "showType": number;
  "freqValue": string;
  "additionalFilter": string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  constructor(data?: TsaimembersettingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tsaimembersetting`.
   */
  public static getModelName() {
    return "Tsaimembersetting";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tsaimembersetting for dynamic purposes.
  **/
  public static factory(data: TsaimembersettingInterface): Tsaimembersetting{
    return new Tsaimembersetting(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tsaimembersetting',
      plural: 'Tsaimembersettings',
      path: 'Tsaimembersettings',
      properties: {
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "aiCode": {
          name: 'aiCode',
          type: 'number'
        },
        "showAi": {
          name: 'showAi',
          type: 'number'
        },
        "showType": {
          name: 'showType',
          type: 'number'
        },
        "freqValue": {
          name: 'freqValue',
          type: 'string'
        },
        "additionalFilter": {
          name: 'additionalFilter',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Tsaimembersetting.ts